module.exports = __webpack_public_path__ + "static/media/Flik7.9b16bc0a.pdf";